import React, { useEffect, useState } from "react";
import styles from "./MemberPage.module.css";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Phone, MessageCircle, Globe } from "lucide-react";

export default function MemberPage() {
  const { id } = useParams();
  const [member, setMember] = useState<any>(null);
  const API = process.env.REACT_APP_API_URL || "http://localhost:8080";
  const nav = useNavigate();

  useEffect(() => {
    if (!id) return;
    axios
      .get(`${API}/api/members/${id}`)
      .then((res) => setMember(res.data.member))
      .catch((error) => {
        console.log("error  while updating memebrs details", error);
        nav("/members");
      });
  }, [id]);

  if (!member) return <p className={styles.loading}>Loading...</p>;

  const whatsappNumber = member.whatsappNo || member.contactNo || "";
  const cleaned = whatsappNumber ? whatsappNumber.replace(/[^\d]/g, "") : "";

  const recognitionIcons: Record<string, string> = {
    "Crorepati Giver": "/images/crorepatiPin.webp",
    "Green Pin": "/images/greenPin.webp",
    "Gold Pin": "/images/goldPin.webp",
    "Leadership Pin": "/images/leadershipPin.webp",
  };

  const normalize = (r: string) => {
    if (!r) return r;
    const lower = r.toLowerCase();
    if (lower.includes("crore") || lower.includes("coro")) {
      return "Crorepati Giver";
    }
    return r;
  };

  const recognitions = Array.isArray(member.recognitions)
    ? member.recognitions.map(normalize)
    : Array.isArray(member.recognition)
    ? member.recognition.map(normalize)
    : [];
  const formatUrl = (url: any) => {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    return "https://" + url;
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.topRow}>
          <div className={styles.left}>
            <div className={styles.avatarWrap}>
              <img
                className={styles.avatar}
                src={
                  member.userImage
                    ? member.userImage
                    : "/images/profile-placeholder.png"
                }
                alt={member.name}
              />
            </div>

            <div className={styles.title}>
              <h2 className={styles.name}>{member.name}</h2>
              <div className={styles.role}>{member.memberType || "Member"}</div>

              <div className={styles.recRow}>
                {recognitions.map((rec: string) => {
                  const iconSrc = recognitionIcons[rec];
                  if (!iconSrc) return null;

                  return (
                    <div key={rec} className={styles.recognitionWrapper}>
                      <img
                        src={iconSrc}
                        alt={rec}
                        className={styles.recPin}
                        onLoad={(e) => {
                          const el = e.currentTarget;
                          const isLandscape =
                            el.naturalWidth > el.naturalHeight + 10;
                          const isPortrait =
                            el.naturalHeight > el.naturalWidth + 10;

                          if (isLandscape) el.classList.add(styles.rectPin);
                          else if (isPortrait) el.classList.add(styles.tallPin);
                          else el.classList.add(styles.roundPin);
                        }}
                      />
                    </div>
                  );
                })}
              </div>

              <div className={styles.quickActions}>
                {member.contactNo && (
                  <a
                    href={`tel:${member.contactNo.replace(/[^\d]/g, "")}`}
                    className={styles.iconBtn}
                  >
                    <Phone size={18} />
                  </a>
                )}
                {cleaned && (
                  <a
                    href={`https://wa.me/${cleaned}`}
                    target="_blank"
                    rel="noreferrer"
                    className={`${styles.iconBtn} ${styles.waBtn}`}
                  >
                    <MessageCircle size={18} />
                  </a>
                )}
                {member.website && (
                  <a
                    href={formatUrl(member.website)}
                    target="_blank"
                    rel="noreferrer"
                    className={`${styles.iconBtn} ${styles.webBtn}`}
                  >
                    <Globe size={18} />
                  </a>
                )}
              </div>
            </div>
          </div>

          <div className={styles.right}>
            {member?.companyLogo && window?.innerWidth > 700 && (
              <div className={styles["comapnyLogoWrapper"]}>
                <img
                  className={styles.companyLogo}
                  src={member?.companyLogo}
                  alt={member.companyLogo}
                />
              </div>
            )}
            <div className={styles.contactRow}>
              {window?.innerWidth > 700 && (
                <div>
                  <strong>Company</strong>
                  <div>{member.orgName || "—"}</div>
                </div>
              )}
              {window?.innerWidth < 700 && (
                <div className={styles["comapnayNameLogoWrapper"]}>
                  <div className={styles.comapanyNameWrapperMobile}>
                    <strong>Company</strong>
                    <div>{member.orgName || "—"}</div>
                  </div>
                  {member?.companyLogo && window?.innerWidth < 700 && (
                    <img
                      className={styles.companyLogo}
                      src={member?.companyLogo}
                      alt={member.companyLogo}
                    />
                  )}
                </div>
              )}
              <div>
                <strong>Phone</strong>
                <div>{member.contactNo || "—"}</div>
              </div>
              <div>
                <strong>Email</strong>
                <div>{member.email || "—"}</div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.bodyGrid}>
          <section>
            <h4>About</h4>
            <p>{member.bio || member.orgBio || "No description available."}</p>
          </section>

          <section>
            <h4>Company Details</h4>
            <p>{member.companyDetails || "No company details provided."}</p>
          </section>

          <section>
            <h4>Social</h4>
            <div className={styles.social}>
              {member.socialHandles?.linkedin && (
                <a href={member.socialHandles.linkedin}>LinkedIn</a>
              )}
              {member.socialHandles?.facebook && (
                <a href={member.socialHandles.facebook}>Facebook</a>
              )}
              {member.socialHandles?.instagram && (
                <a href={member.socialHandles.instagram}>Instagram</a>
              )}
            </div>
          </section>
          <section>
            <h4>Address</h4>
            <p>{member?.address || "No Address available."}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
